import React from 'react'
import { FormControl, InputLabel, Input } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

export default withStyles(theme => ({
  underline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: '#ECEFF1',
    },
  },
  whiteUnderline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: '#FFFFFF',
    },
    '&&&&:hover:before': {
      borderColor: '#FFF',
    },
    '&:after': {
      borderColor: '#FFFFFF',
    },
    '&:hover:after': {
      borderColor: '#FFFFFF',
    },
  },
  whiteInput: {
    '&,&::placeholder': {
      color: '#FFFFFF',
      opacity: '1',
    },
  },
  disabled: {},
}))(
  ({
    title,
    id,
    style,
    fullWidth,
    classes,
    white,
    labelProps,
    error,
    ...props
  }) => {
    return (
      <FormControl
        style={{
          marginTop: 10,
        }}
        fullWidth={fullWidth}
      >
        <InputLabel
          style={{
            color: white ? '#FFF' : null,
          }}
          htmlFor={id}
          error={error}
          {...labelProps}
        >
          {title}
        </InputLabel>
        <Input
          classes={{
            input: white ? classes.whiteInput : classes.input,
            underline: white ? classes.whiteUnderline : classes.underline,
          }}
          id={id}
          fullWidth={fullWidth}
          error={error}
          {...props}
        />
      </FormControl>
    )
  }
)
